import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

export default function LegacyProjectModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  console.log('LegacyProjectModal - open:', open);

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onClose();
    }
  };

  return (
    <Modal
      title="Your legacy project"
      open={open}
      onOpenChange={handleOpenChange}
      maxWidth={800}
    >
      <div className="space-y-4">
        <div className="relative aspect-video w-full overflow-hidden rounded-lg">
          <Video
            src="/videos/legacy_create_new.webm"
            mode="autoplay"
            className="absolute inset-0 h-full w-full scale-110 object-cover"
            crossOrigin="anonymous"
          />
        </div>
        <Text variant="studio/body/md">
          Your legacy project contains all the motions you've created prior to
          the launch of sequence builder. You will not be able to edit or add
          new motions to this project.
          <br />
          <br />
          To use these legacy motions with the new sequence builder or download
          them, access the <strong>History</strong> panel and select{' '}
          <strong>"Create as new project."</strong>
        </Text>
        <div className="mt-2 flex justify-end">
          <Button variant="primary" onClick={onClose}>
            Okay
          </Button>
        </div>
      </div>
    </Modal>
  );
}
